import { useQuery } from '@tanstack/react-query';
import { getCounter } from 'config/requests';

export function useGetCounter(resource: string) {
  const { data, isLoading } = useQuery({
    queryKey: [resource],
    queryFn: () => getCounter(resource),
  });

  return { data, isLoading };
}
